goog.provide('el8.appshared.dialog.confirmPassportRegistration');

goog.require('el8.ptdata.patients');
goog.require('el8.template.appshared.dialog.confirmPassportRegistration');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');

el8.appshared.dialog.confirmPassportRegistration = (function() {

    var isFromLetter = false;
    var patientId = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Success!',
        width: 400,
        position: 'center',
        autoHeight: true
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'print-close', 'Print Passport Info Document & Close', function() {
            window.open(el8.service.urls.get('printInviteCode'));
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var super_show = that.show;
    that.show = function(_patientId, _fromLetter) {
        patientId = _patientId;
        isFromLetter = _fromLetter;

        super_show.call(that);
        that.setContent(
            el8.template.appshared.dialog.confirmPassportRegistration.content({
                isFromLetter: isFromLetter,
                patient: el8.ptdata.patients.getById(patientId).asSoyMap()
            })
        );
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        isFromLetter = false;
        patientId = null;
    };

    return that;

})();

